import { render, staticRenderFns } from "./commonTabBar.vue?vue&type=template&id=2bfd5459&scoped=true"
import script from "./commonTabBar.vue?vue&type=script&lang=js"
export * from "./commonTabBar.vue?vue&type=script&lang=js"
import style0 from "./commonTabBar.vue?vue&type=style&index=0&id=2bfd5459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd5459",
  null
  
)

export default component.exports